var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManualsLogo = function SvgManualsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 151,
    viewBox: "0 0 208 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.032 8.396c-12.482-6.632-23.81-9.317-39.158-5.65v55.019c15.514-3.565 24.067.404 39.158 3.93m0-53.299c11.992-7.123 23.903-9.308 39.158-5.65v55.019c-15.006-3.59-23.645.32-39.158 3.93m0-53.299v53.299",
    stroke: "#2C112D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.424 17.425c-8.158-3.896-13.102-5.6-24.474-4.626M154.424 25.257c-8.158-3.896-13.102-5.6-24.474-4.627M154.424 33.088c-8.158-3.896-13.102-5.6-24.474-4.626M154.424 40.92c-8.158-3.896-13.102-5.6-24.474-4.626M154.424 48.752c-8.158-3.896-13.102-5.6-24.474-4.626M167.64 17.425c8.158-3.896 13.102-5.6 24.473-4.626M167.64 25.257c8.158-3.896 13.102-5.6 24.473-4.627M167.64 33.088c8.158-3.896 13.102-5.6 24.473-4.626M167.64 40.92c8.158-3.896 13.102-5.6 24.473-4.626M167.64 48.752c8.158-3.896 13.102-5.6 24.473-4.626",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m116 8.832.734 53.842c15.781-4.841 25.177-2.29 44.298-1.224 20.34-1.04 31.145-3.616 45.031 1.224V8.832",
    stroke: "#2C112D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.524 112.508c5.159 0 9.391-4.233 9.391-9.391 0-5.16-4.232-9.392-9.391-9.392s-9.392 4.233-9.392 9.392c0 5.158 4.1 9.391 9.392 9.391ZM130.952 112.508c5.159 0 9.392-4.233 9.392-9.391 0-5.16-4.233-9.392-9.392-9.392s-9.391 4.233-9.391 9.392c0 5.158 4.232 9.391 9.391 9.391ZM42.592 74.81v26.322c0 2.117-1.72 3.704-3.703 3.704H8.73",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.132 18.46v67.725h22.62l7.54 18.783h30.026l7.407-18.783h22.619l-1.984-7.672s-14.947-7.407-30.027-7.407H87.698M50.132 74.81h-7.54",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m65.08 86.185 3.306-26.852c.264-1.852 1.852-3.307 3.704-3.307h11.772c2.117 0 3.704 1.72 3.704 3.704v26.323M91.402 86.186H65.079M91.402 86.186v18.783",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgManualsLogo;